import productLineLetter from '../../utils/api/getProductLineLetter';
import { useApiHost, useAppName, useLanguage, useUserOrDefaultProvince } from '../../utils/sitecoreContext';
export const useApiConfig = () => {
    const appName = useAppName();
    const hondaRestApiHost = useApiHost();
    const provinceCode = useUserOrDefaultProvince();
    const productLineCode = productLineLetter.get(appName);
    const languageCode = useLanguage();
    const hostname = hondaRestApiHost ? `https://${hondaRestApiHost}` : '';
    return {
        hostname,
        provinceCode,
        languageCode,
        productLineCode,
    };
};
export default useApiConfig;
